module.exports = __webpack_public_path__ + "img/rope_1ThimbleBraid_1eye_2.d7175c00.png";